import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { AuthLayout, FormError } from "../components/AuthLayout";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(f);
      nav("/scan");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Join the crew" subtitle="Free forever. Your first name shows on the leaderboard.">
      <form onSubmit={submit} className="space-y-5" data-testid="signup-form">
        <div>
          <label className="brut-label">First name</label>
          <input className="brut-input" required maxLength={40} autoComplete="given-name" value={f.first_name}
            onChange={set("first_name")} data-testid="signup-first-name-input" />
        </div>
        <div>
          <label className="brut-label">Email</label>
          <input className="brut-input" type="email" required autoComplete="email" value={f.email}
            onChange={set("email")} data-testid="signup-email-input" />
        </div>
        <div>
          <label className="brut-label">Password (8+ characters)</label>
          <input className="brut-input" type="password" required minLength={8} autoComplete="new-password" value={f.password}
            onChange={set("password")} data-testid="signup-password-input" />
        </div>
        <FormError msg={error} testId="signup-error" />
        <button className="brut-btn w-full" disabled={busy} data-testid="signup-submit-btn">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <p className="mt-6 text-sm text-zinc-400">
        Already fishing with us? <Link to="/login" className="text-[#FF4D00] font-bold" data-testid="signup-login-link">Log in</Link>
      </p>
    </AuthLayout>
  );
}
